import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: normal;
  background-color: #e9ecef;
  color: #495057;
  padding: 5px;
  border-radius: 3px 0 0 3px;
  flex-grow: 1;
`;
